<template>
  <div class="">
    <h2 class="ViewHeading">Water Management Support</h2>
    <div>
      <b-container>
        <b-row>
          <b-col>
            <br />
          </b-col>
        </b-row>
        <b-row>
          <!-- <b-button variant="outline-info">Filter Results</b-button>
          <b-button variant="outline-info">Reset</b-button> -->
          <!-- <b-col>
            <b-button variant="outline-info" v-b-modal.newticket
              >New Ticket</b-button
            >
          </b-col> -->
        </b-row>
        <b-row>
          <b-col>
            <br />
          </b-col>
        </b-row>
      </b-container>
      <b-modal
        id="newticket"
        hide-footer
        lazy
        content-class="Modal"
        header-bg-variant="light"
        footer-bg-variant="light"
        title="New Support Ticket"
        ok-only
      >
        <b-card
          border-variant="dark"
          align="center"
          header-bg-variant="secondary"
          footer-tag="footer"
        >
          <template #header>
            <h4>Raise a Support Request</h4>
          </template>
          <b-card-sub-title>
            Use this form to submit any incidents, problems or support requests
          </b-card-sub-title>
          <br />
          <b-card-sub-title>
            Please complete below details
          </b-card-sub-title>
          <br />

          <b-card>
            <b-col cols="12">
              <label>Full Name</label>
            </b-col>
            <input
              id="reqraised"
              type="text"
              placeholder="Request Raised by"
              v-model="userID"
              required
              :readonly="true"
              @focus="modal = false"
            />
            <br />
            <b-col cols="12"><label>Contact Email</label></b-col>
            <input
              id="contactemail"
              maxlength="90"
              type="email"
              placeholder="User Email Address"
              v-model="UserEmail"
              @focus="modal = false"
              required
            />
            <b-col cols="12"><label for="">Request Type</label></b-col>
            <select
              name="RequestDrop"
              v-model="RequestDrop"
              id="RequestDrop"
              @focus="modal = false"
              required
            >
              <option select disabled value=""></option>
              <option>Clarence Software Support</option>
              <option>Maintenance Support</option>
            </select>
            <b-col cols="12"><label for="">Location</label></b-col>
            <input
              type="text"
              placeholder="Location"
              v-model="this.userLocation"
              required
              :readonly="true"
              @focus="modal = false"
            />
            <br />
          </b-card>

          <br />
          <b-card>
            <b-row>
              <b-form-radio-group
                v-model="selected"
                :options="optionsUrgency"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
                @focus="modal = false"
              ></b-form-radio-group>
            </b-row>
            <br />
            <b-col cols="12"
              ><label for="">
                Please describe in as much detail as possible the reason for the
                request. (1000 Character Max)</label
              ></b-col
            >

            <textarea
              class="supportTextArea"
              v-model="message"
              placeholder="Description"
              rows="6"
              cols="45"
              @focus="modal = false"
              maxlength="1000"
            ></textarea>
          </b-card>
          <br />
          <b-button
            variant="outline-info"
            v-on:click="
              checkmodal(
                checkedactions,
                StatusUpdate,
                messageforcontact,
                ServiceAssign,
                ServiceType
              )
            "
          >
            Submit
          </b-button>
          <b-button variant="outline-info" v-on:click="resetSupportActions()">
            Reset
          </b-button>
        </b-card>
      </b-modal>
      <div class="Container">
        <p>Current Open Requests for User</p>
        <br />
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="Requesttable"
        ></b-pagination>

        <b-table
          id="RequestTable"
          @row-dblclicked="rowDblClickHandler"
          :items="this.items"
          :fields="this.fields"
          :per-page="perPage"
          :current-page="currentPage"
          empty-text="You currently dont have any open support requests"
          no-border-collapse
          hover
          show-empty
          responsive
          small
          sticky-header
        >
          <template v-slot:empty="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template v-slot:cell(Action)="{ item }">
            <b-button
              variant="outline-info"
              v-on:click="
                showActionModal(
                  item[0],
                  item[1],
                  item[2],
                  item[3],
                  item[4],
                  item[5],
                  item[6],
                  item[7]
                )
              "
            >
              Cancel
            </b-button>
          </template>
        </b-table>
        <br />
      </div>
      <b-modal
        ref="CombinedSupportActionModal"
        id="CombinedSupportActionModal"
        hide-footer
        title="Support Action Form"
        content-class="Modal"
      >
        <div>
          <p class="head">
            Support Ticket: {{ this.item0 }} - Category: {{ this.item5 }}
          </p>
          <p class="head">Location: {{ this.item2 }}</p>
          <p class="head">
            Raised By: {{ this.item1 }} - Raised On: {{ this.item3 }}
          </p>
          <p class="head">
            Urgency: {{ this.item4 }} - Status: {{ this.item7 }}
          </p>
          <p class="head">Acknowledged: {{ this.item6 }}</p>
          <br />
          <p>Would you like to cancel this request?</p>
        </div>
        <div>
          <button class="button" v-on:click="checkmodal()">Yes</button>
          <button class="button" v-on:click="resetmodal()">No</button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  computed: {},
  components: {},

  data() {
    return {
      optionsUrgency: [
        { item: "Highly Urgent", name: "Highly Urgent (12hr)" },
        { item: "Urgent", name: "Urgent (24hr)" },
        { item: "Routine", name: "Routine (48hr)" },
        { item: "Non Urgent", name: "Non Urgent (1 Week)" },
      ],
      file: "",
      DeviceID: "123456789",
      Folder: "attachments",
      items: [],
      UserHeaders: [],
      response: null,
      ArrTest: [],
      perPage: 5,
      currentPage: 1,
      rowDblClickHandler: "",
      modal: false,
      item0: "",
      item1: "",
      item2: "",
      item3: "",
      item4: "",
      showOverlay: false,
      duplicatefile: false,
      fields: [
        "Request ID",
        "Raised By",
        "EMail",
        "Location",
        "Date Raised",
        "Urgency",
        "Category",
        "Acknowledged",
        "Status",
        "Detail",
        "Action",
      ],
      userID: "",
      UserEmail: "",
      RequestDrop: "",
      userLocation: "",
      selected: "",
      message: "",
      rows: "",
      item5: "",
      item7: "",
      item6: "",
    };
  },

  beforeMount() {},

  mounted() {},

  methods: {
    showActionModal(var0, var1, var2, var3, var4) {
      this.item0 = var0;
      this.item1 = var1;
      this.item2 = var2;
      this.item3 = var3;
      this.item4 = var4;
      this.$refs["CombinedSupportActionModal"].show(
        this.item0,
        this.item1,
        this.item2,
        this.item3,
        this.item4
      );
    },

    resetmodal() {
      this.$refs["CombinedSupportActionModal"].hide();
    },
  },
};
</script>

<style>
input[type="file"] {
  display: none;
}
input[type="text"],
select {
  width: 75%;
  padding: 5px 5px 5px 5px;
  border: solid 1px rgba(200, 200, 200, 0.5);
  background-color: rgb(245, 245, 245);
}
.custom-file-upload {
  border: 1px solid cadetblue;
  border-radius: 5px;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  color: cadetblue;
}

#Table {
  margin: auto;
  text-align: center;
}

#cancel-label {
  color: white;
  font-size: large;
}

.Upload label {
  font-size: 15px;
}

.modal {
  text-align: center;
}
#contactemail {
  width: 75%;
  padding: 5px 5px 5px 5px;
  border: solid 1px rgba(200, 200, 200, 0.5);
  background-color: rgb(245, 245, 245);
}
</style>
